import { AuthProvider } from 'react-admin'
import { loginMutation, confirmCodeMutation, logoutMutation } from '../graphql/mutations'
import { currentUserQuery } from '../graphql/queries'
import apolloClient from './data/apollo-client'

export const authProvider: AuthProvider = {
  login: async (logins) => {
    const { username, password, code } = logins
    try {
      if (code) {
        await apolloClient.mutate({
          mutation: confirmCodeMutation,
          variables: { email: username, password: password, code }
        })
      } else {
        const { data } = await apolloClient.mutate({
          mutation: loginMutation,
          variables: { email: username, password: password }
        })
        if (data?.login?.status === 'code_sent') {
          return Promise.reject({
            status: 'code_sent',
            email: username,
            password
          })
        }
      }
      const {
        data: { currentUser }
      } = await apolloClient.query({ query: currentUserQuery })
      if (
        !currentUser ||
        (currentUser.role !== 'superadmin' && currentUser.role !== 'admin')
      ) {
        console.error('Not authenticated!')
        await apolloClient.mutate({ mutation: logoutMutation })
        return Promise.reject()
      }
      localStorage.setItem('permissions', currentUser.role)
      localStorage.setItem('customerId', currentUser.customerId)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  },

  logout: async () => {
    try {
      await apolloClient.mutate({ mutation: logoutMutation })
    } catch (err) {
      console.error(err)
    }
    localStorage.removeItem('permissions')
    localStorage.removeItem('customerId')
    return Promise.resolve('/login')
  },

  checkAuth: async () => {
    try {
      const {
        data: { currentUser }
      } = await apolloClient.query({ query: currentUserQuery })
      if (
        !currentUser ||
        (currentUser.role !== 'superadmin' && currentUser.role !== 'admin')
      ) {
        console.error('Not authenticated!')
        return Promise.reject()
      }
      localStorage.setItem('permissions', currentUser.role)
      localStorage.setItem('customerId', currentUser.customerId)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject()
    }
  },

  getPermissions: async () => {
    const role = localStorage.getItem('permissions')
    const customerId = localStorage.getItem('customerId')
    if (!role || !customerId) {
      const {
        data: { currentUser }
      } = await apolloClient.query({ query: currentUserQuery })
      if (
        !currentUser ||
        (currentUser.role !== 'superadmin' && currentUser.role !== 'admin')
      ) {
        console.error('Not authenticated!')
        return Promise.reject()
      } else {
        return Promise.resolve({
          role: currentUser.role,
          customerId: currentUser.customerId
        })
      }
    }
    return role
      ? Promise.resolve({ role: role, customerId: customerId })
      : Promise.reject()
  },

  getIdentity: () => Promise.reject(),
  checkError: () => Promise.resolve()
}
